(function() {
  // Collection infinity scroll
  const collectionContainer = document.querySelector("#main-collection-product-grid");

  if (collectionContainer) {
    let isLoading = false;
    document.addEventListener("scroll", () => {
      if ((window.innerHeight >= collectionContainer.scrollHeight + collectionContainer.getBoundingClientRect().top)) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const currentPage = parseInt(collectionContainer.dataset.current);
        const pagesAmount = parseInt(collectionContainer.dataset.pages);

        if (currentPage < pagesAmount && !isLoading) {
          urlSearchParams.set('page', currentPage + 1);

          const url = window.location.pathname + '?' + urlSearchParams.toString();
          
          isLoading = true;
          collectionContainer.classList.add("loading");

          console.log(url);

          fetch(url).then(res => res.text()).then(res => {
            const html = new DOMParser().parseFromString(res, 'text/html');
      
            collectionContainer.innerHTML += html.querySelector("#main-collection-product-grid").innerHTML;
      
            collectionContainer.setAttribute('data-current', html.querySelector("#main-collection-product-grid").dataset.current);
            collectionContainer.setAttribute('data-pages', html.querySelector("#main-collection-product-grid").dataset.pages);

            collectionContainer.querySelectorAll(".product-item__wishlist").forEach(item => item.classList.add("swym-loaded", "ts-loaded"));
      
            isLoading = false;
            collectionContainer.classList.remove("loading");
            
            const urlSearchParams = new URLSearchParams(url.split('?')[1]);
            urlSearchParams.delete("page");
            window.history.replaceState({}, '', window.location.origin + window.location.pathname + '?' + urlSearchParams.toString());

            if (st.loadLabelsByHandle) {
              st.loadLabelsByHandle();
            }
          })
        }
      }
    })

    let listId = undefined;
    document.addEventListener("click", (e) => {
      if(e.target.classList.contains("ts-loaded")) {
        e.preventDefault();
        if (!listId) {
          _swat.fetchLists({
            callbackFn: function(lists){
              listId = lists[0].lid;
              tsAddToWish(listId, e.target);
            }
          });
        } else {
          tsAddToWish(listId, e.target);
        }
      }
    })

    function tsAddToWish(listId, element) {
      let product = {
        epi: parseInt(element.closest(".grid__item").dataset.variant), // Unique variant ID of the product
        empi: parseInt(element.closest(".grid__item").dataset.id), // Master Product Id of the product
        du: window.location.origin + element.closest(".grid__item").dataset.url, // Product URL
      };

      function onSuccess() {
        element.classList.add("disabled","swym-added");
      }

      function onError() {
        console.log("Something going wrong");
      }

      _swat.addToList(listId, product, onSuccess, onError);
    }
  }
})();